/**
 * Pre-configured route exports for the single-file approach
 * Users can import these directly in their route.ts file
 */

import { createHandler } from './handler';

// Create a default handler instance
const handler = createHandler();

// Export all HTTP methods
export const GET = handler;
export const POST = handler;
export const PUT = handler;
export const DELETE = handler;
export const PATCH = handler;
export const OPTIONS = handler;

// Also export the handler creator for custom configurations
export { createHandler };